import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export const ZAssetKPI = z.object({
  kpiDefinitionId: z.string(),
  parameterName: z.string(),
  unit: z.string()
})
export const ZKPI = z.object({
  isTotalizer: z.boolean().optional().nullable(),
  isCustomKpi: z.boolean().optional().nullable(),
  totalizerType: z.string().optional().nullable(),
  kpiDefinitionId: z.string(),
  parameterName: z.string(),
  unit: z.string().nullable()
})
export const ZRegisters = z.object({
  cimCodeId: z.string(),
  parameterName: z.string(),
  unit: z.string().nullable()
})
export const ZDevice = z.object({
  id: z.string(),
  name: z.string(),
  deviceTypeId: z.string(),
  registers: z.array(ZRegisters).optional(),
  kpis: z.array(ZKPI).optional()
})
export const ZGateway = z.object({
  id: z.string(),
  name: z.string(),
  device: z.array(ZDevice).optional()
})
export const ZData = z.object({
  id: z.string(),
  name: z.string(),
  gateway: z.array(ZGateway).optional(),
  assetKPIs: z.array(ZAssetKPI).optional()
})

export const ZApiResponse = z.object({
  http_status: z.number(),
  data: z.optional(ZData),
  error: z.boolean()
})

export type GetParametersResponce = z.infer<typeof ZData>
export type GetParametersResponceAPIData = z.infer<typeof ZApiResponse>

export async function fetchParameterConfigurations (
  siteID: string,
  assetID: string,
  onSuccess: (device: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const DeviceManagementStrings =
    LanguageStrings().SiteManagementCollectionStrings.TableComponent
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/hierarchy/${siteID}/${assetID}`
  interceptedAxios
    .get(url, { timeout: 20000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined || error.response.data !== null
            ? error.response.data.error_message
            : DeviceManagementStrings.NetworkError,
          error.response.status
        )
      } else {
        onFailure(DeviceManagementStrings.NetworkError, 404)
      }
    })
}
